



    import { Component, Vue } from "vue-property-decorator";
    import NewsPage from '@/components/news/index.vue';

	@Component({
        components: {
           NewsPage 
        }
    })
	export default class News extends Vue {
        
    }
